/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetProducts200ResponseItemsInnerInformation } from './GetProducts200ResponseItemsInnerInformation';
import {
    GetProducts200ResponseItemsInnerInformationFromJSON,
    GetProducts200ResponseItemsInnerInformationFromJSONTyped,
    GetProducts200ResponseItemsInnerInformationToJSON,
    GetProducts200ResponseItemsInnerInformationToJSONTyped,
} from './GetProducts200ResponseItemsInnerInformation';
import type { PatchProductsRequestInnerAllOfSchedulesInner } from './PatchProductsRequestInnerAllOfSchedulesInner';
import {
    PatchProductsRequestInnerAllOfSchedulesInnerFromJSON,
    PatchProductsRequestInnerAllOfSchedulesInnerFromJSONTyped,
    PatchProductsRequestInnerAllOfSchedulesInnerToJSON,
    PatchProductsRequestInnerAllOfSchedulesInnerToJSONTyped,
} from './PatchProductsRequestInnerAllOfSchedulesInner';
import type { PatchProductsRequestInnerAllOfAllergensInner } from './PatchProductsRequestInnerAllOfAllergensInner';
import {
    PatchProductsRequestInnerAllOfAllergensInnerFromJSON,
    PatchProductsRequestInnerAllOfAllergensInnerFromJSONTyped,
    PatchProductsRequestInnerAllOfAllergensInnerToJSON,
    PatchProductsRequestInnerAllOfAllergensInnerToJSONTyped,
} from './PatchProductsRequestInnerAllOfAllergensInner';

/**
 * 
 * @export
 * @interface CreateProductRequest
 */
export interface CreateProductRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateProductRequest
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductRequest
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateProductRequest
     */
    enabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateProductRequest
     */
    price: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateProductRequest
     */
    modifierGroups: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateProductRequest
     */
    hasSchedule: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateProductRequest
     */
    controlEnabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateProductRequest
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateProductRequest
     */
    imageId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateProductRequest
     */
    kitchenName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateProductRequest
     */
    shortName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateProductRequest
     */
    color?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateProductRequest
     */
    course?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateProductRequest
     */
    taxCategories?: string | null;
    /**
     * 
     * @type {Array<PatchProductsRequestInnerAllOfAllergensInner>}
     * @memberof CreateProductRequest
     */
    allergens?: Array<PatchProductsRequestInnerAllOfAllergensInner>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateProductRequest
     */
    specifications?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateProductRequest
     */
    additives?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateProductRequest
     */
    isPrepackaged?: boolean | null;
    /**
     * 
     * @type {GetProducts200ResponseItemsInnerInformation}
     * @memberof CreateProductRequest
     */
    information: GetProducts200ResponseItemsInnerInformation | null;
    /**
     * 
     * @type {Array<PatchProductsRequestInnerAllOfSchedulesInner>}
     * @memberof CreateProductRequest
     */
    schedules?: Array<PatchProductsRequestInnerAllOfSchedulesInner>;
}

/**
 * Check if a given object implements the CreateProductRequest interface.
 */
export function instanceOfCreateProductRequest(value: object): value is CreateProductRequest {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('modifierGroups' in value) || value['modifierGroups'] === undefined) return false;
    if (!('hasSchedule' in value) || value['hasSchedule'] === undefined) return false;
    if (!('controlEnabled' in value) || value['controlEnabled'] === undefined) return false;
    if (!('information' in value) || value['information'] === undefined) return false;
    return true;
}

export function CreateProductRequestFromJSON(json: any): CreateProductRequest {
    return CreateProductRequestFromJSONTyped(json, false);
}

export function CreateProductRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateProductRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'enabled': json['enabled'],
        'price': json['price'],
        'modifierGroups': json['modifierGroups'],
        'hasSchedule': json['hasSchedule'],
        'controlEnabled': json['controlEnabled'],
        'description': json['description'] == null ? undefined : json['description'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'kitchenName': json['kitchenName'] == null ? undefined : json['kitchenName'],
        'shortName': json['shortName'] == null ? undefined : json['shortName'],
        'color': json['color'] == null ? undefined : json['color'],
        'course': json['course'] == null ? undefined : json['course'],
        'taxCategories': json['taxCategories'] == null ? undefined : json['taxCategories'],
        'allergens': json['allergens'] == null ? undefined : ((json['allergens'] as Array<any>).map(PatchProductsRequestInnerAllOfAllergensInnerFromJSON)),
        'specifications': json['specifications'] == null ? undefined : json['specifications'],
        'additives': json['additives'] == null ? undefined : json['additives'],
        'isPrepackaged': json['isPrepackaged'] == null ? undefined : json['isPrepackaged'],
        'information': GetProducts200ResponseItemsInnerInformationFromJSON(json['information']),
        'schedules': json['schedules'] == null ? undefined : ((json['schedules'] as Array<any>).map(PatchProductsRequestInnerAllOfSchedulesInnerFromJSON)),
    };
}

export function CreateProductRequestToJSON(json: any): CreateProductRequest {
    return CreateProductRequestToJSONTyped(json, false);
}

export function CreateProductRequestToJSONTyped(value?: CreateProductRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'enabled': value['enabled'],
        'price': value['price'],
        'modifierGroups': value['modifierGroups'],
        'hasSchedule': value['hasSchedule'],
        'controlEnabled': value['controlEnabled'],
        'description': value['description'],
        'imageId': value['imageId'],
        'kitchenName': value['kitchenName'],
        'shortName': value['shortName'],
        'color': value['color'],
        'course': value['course'],
        'taxCategories': value['taxCategories'],
        'allergens': value['allergens'] == null ? undefined : ((value['allergens'] as Array<any>).map(PatchProductsRequestInnerAllOfAllergensInnerToJSON)),
        'specifications': value['specifications'],
        'additives': value['additives'],
        'isPrepackaged': value['isPrepackaged'],
        'information': GetProducts200ResponseItemsInnerInformationToJSON(value['information']),
        'schedules': value['schedules'] == null ? undefined : ((value['schedules'] as Array<any>).map(PatchProductsRequestInnerAllOfSchedulesInnerToJSON)),
    };
}

